export const SET_FREE_TRIAL_LANGUAGE_ID = "SET_FREE_TRIAL_LANGUAGE_ID";
export const SET_FREE_TRIAL_FORM_SUBMISSION = "SET_FREE_TRIAL_FORM_SUBMISSION";
export const SET_FREE_TRIAL_IS_LOADING = "SET_FREE_TRIAL_IS_LOADING";
export const SET_FREE_TRIAL_SUBMISSION_RESPONSE = "SET_FREE_TRIAL_SUBMISSION_RESPONSE";
export const SET_FREE_TRIAL_SUBMISSION_STATUS = "SET_FREE_TRIAL_SUBMISSION_STATUS";
export const SET_FREE_TRIAL_SUBMISSION_ERROR = "SET_FREE_TRIAL_SUBMISSION_ERROR";
export const CLEAR_FREE_TRIAL_SUBMISSION_ERROR = "CLEAR_FREE_TRIAL_SUBMISSION_ERROR";
